/*
 * 工单处理列表 tab页 获取自动外呼记录和催收记录
 * */
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { GetAllAutoCallResultReq, GetCaseLogDetailReq } from "@/pbjs/xcommon/collection_pb.js";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";

export interface Options {
    Page: Page;
    mobile?: string;
}
export interface CaseLogOptions {
    Page: Page;
    caseid?: number;
    itemid?: number;
    orderid?: string;
}
export function setGetAllAutoCallResultReq(arg: Options) {
    let request: any = new GetAllAutoCallResultReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setMobile(arg.mobile);
    return request;
}
export function setGetCaseLogDetailReq(arg: CaseLogOptions) {
    let request: any = new GetCaseLogDetailReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setCaseid(arg.caseid);
    request.setItemid(arg.itemid);
    request.setOrderid(arg.orderid);
    return request;
}
export const getAllAutoCallResult = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.getAllAutoCallResult
);
export const getCaseLogDetail = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.getCaseLogDetail
);
